module.exports = __webpack_public_path__ + "static/media/vr-cardboard.3807c2ce.svg";